<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Role To User</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">
            New Role To User
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    v-model="editedItem.role_id"
                    :items="indexData.roles"
                    item-text="title"
                    item-value="id"
                    box
                    label="Select Role"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <v-autocomplete
                    v-model="editedItem.user_id"
                    :items="indexData.officialUsers"
                    item-text="name"
                    item-value="id"
                    box
                    label="Select User"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click="save">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="indexData.roleToUsers"
      :search="search"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-center">{{ props.item.role.title }}</td>
        <td class="text-xs-center">{{ props.item.official_user.name }}</td>
        <td class="justify-center layout px-0">
          <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
          <v-icon small @click="deleteItem(props.item)">delete</v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      search: "",
      apiUrl: "role-user",
      headers: [
        {
          text: "Serial No",
          align: "center",
          value: "serial_no",
          sortable: false,
        },
        { text: "Role", align: "center", value: "role.title", sortable: true },
        {
          text: "Official User Name",
          align: "center",
          value: "official_user.name",
          sortable: true,
        },
        { text: "Actions", align: "center", value: "actions" },
      ],
      editedIndex: -1,
      editedItem: {
        role_id: "",
        user_id: "",
        role: {
          title: "",
        },
        official_user: {
          name: "",
          phone: "",
        },
      },
      defaultItem: {
        role_id: "",
        user_id: "",
        role: {
          title: "",
        },
        official_user: {
          name: "",
          phone: "",
        },
      },
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
        "investorAgreement",
        "investeeAgreement",
        "userImage",
        "docImage",
      ]),
      formTitle() {
        return this.editedIndex === -1
          ? "New Role To User"
          : "Edit Role To User";
      },
    },

    watch: {
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.$store.dispatch("setIndexData", [this.apiUrl]);
      },

      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      editItem(item) {
        this.editedIndex = this.indexData.roleToUsers.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },

      deleteItem(item) {
        const index = this.indexData.roleToUsers.indexOf(item);
        var result =
          confirm("Are you sure you want to delete this item?") &&
          this.indexData.roleToUsers.splice(index, 1);
        if (result) {
          this.$store.dispatch("delete", [this.apiUrl, item.id]);
          this.initialize();
        }
      },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      save() {
        if (this.editedIndex > -1) {
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        } else {
          this.$store.dispatch("store", [this.apiUrl, this.editedItem]);
        }
        this.close();
      },
    },
  };
</script>
